import { HelpCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';
import { useHelpDrawer } from './HelpDrawerContext';

interface HelpButtonProps {
  pageKey: string;
}

export function HelpButton({ pageKey }: HelpButtonProps) {
  const { openHelp } = useHelpDrawer();

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            variant="outline"
            size="sm"
            className="gap-1.5 h-8"
            onClick={() => openHelp(pageKey)}
          >
            <HelpCircle className="h-4 w-4" />
            Help
          </Button>
        </TooltipTrigger>
        <TooltipContent side="bottom">
          <p>Get help with this page</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
